import axios from "axios";

const AbsentLast5Service = {
  // sdate / edate must be "YYYY-MM-DD"
  async getAll(sdate, edate) {
    try {
      const response = await axios.get(
        `/Attendence/GetAbsenteeismDetails?sdate=${sdate}&edate=${edate}`
      );
      const d = response.data || {};
      const rows = d.ResultSet ?? d.resultSet;
      if (Array.isArray(rows)) return rows;
      console.warn("Absenteeism API response format unexpected:", d);
      return [];
    } catch (error) {
      console.error("Error fetching absenteeism data:", error);
      throw error;
    }
  },
};

export default AbsentLast5Service;